var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "工號" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.empNo,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "empNo", $$v)
                              },
                              expression: "queryParam.empNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "廠區" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.factoryCode,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "factoryCode", $$v)
                              },
                              expression: "queryParam.factoryCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "法人" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.companyCode,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "companyCode", $$v)
                              },
                              expression: "queryParam.companyCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "siteId" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.siteId,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "siteId", $$v)
                              },
                              expression: "queryParam.siteId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "費用代碼" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.costCode,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "costCode", $$v)
                              },
                              expression: "queryParam.costCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "事業群" } },
                        [
                          _c("a-input", {
                            attrs: { "allow-clear": "" },
                            model: {
                              value: _vm.queryParam.bgCode,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "bgCode", $$v)
                              },
                              expression: "queryParam.bgCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "在職/離職" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: "請選擇在職/離職",
                                allowClear: ""
                              },
                              model: {
                                value: _vm.queryParam.jobSt,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "jobSt", $$v)
                                },
                                expression: "queryParam.jobSt"
                              }
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "JOB_ST001" } },
                                [_vm._v("JOB_ST001 在職（Y）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "JOB_ST004" } },
                                [_vm._v("JOB_ST004 離職（N）")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "人員類型" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: "請選擇人員類型",
                                allowClear: ""
                              },
                              model: {
                                value: _vm.queryParam.empType,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "empType", $$v)
                                },
                                expression: "queryParam.empType"
                              }
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "EO" } },
                                [_vm._v("EO 正式工（Y）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "ET" } },
                                [_vm._v("ET 退休返聘（Y）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "CON" } },
                                [_vm._v("CON 顧問（N）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "EB" } },
                                [_vm._v("EB 廠商派駐（N）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "ED" } },
                                [_vm._v("ED 派遣工（N）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "EE" } },
                                [_vm._v("EE 勤工助學（N）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "EF" } },
                                [_vm._v("EF 學徒工（N）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "EJ" } },
                                [_vm._v("EJ 見習生（N）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "EP" } },
                                [_vm._v("EP 實習工（N）")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExportXls("emp_chr_employee")
                }
              }
            },
            [_vm._v("导出")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "sync" },
              on: { click: _vm.showSyncModal }
            },
            [_vm._v("同步員工信息")]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("p", [_vm._v("備註：")]),
              _c("p", [_vm._v("JOB_ST001 在職、JOB_ST004 離職")]),
              _c("p", [
                _vm._v(
                  "EO 正式工、ET 退休返聘、CON 顧問、EB 廠商派駐、ED 派遣工、EE 勤工助學、EF 學徒工、EJ 見習生、EP 實習工"
                )
              ])
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: true },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "htmlSlot",
                fn: function(text) {
                  return [_c("div", { domProps: { innerHTML: _vm._s(text) } })]
                }
              },
              {
                key: "imgSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic"
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "25px",
                            alt: ""
                          }
                        })
                  ]
                }
              },
              {
                key: "fileSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无文件")]
                        )
                      : _c(
                          "a-button",
                          {
                            attrs: {
                              ghost: true,
                              type: "primary",
                              icon: "download",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(text)
                              }
                            }
                          },
                          [_vm._v("\n          下载\n        ")]
                        )
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v("更多 "),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDetail(record)
                                      }
                                    }
                                  },
                                  [_vm._v("详情")]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("emp-chr-employee-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "同步員工信息",
            visible: _vm.syncModalVisible,
            confirmLoading: _vm.syncModalConfirmLoading,
            width: 600
          },
          on: { ok: _vm.confirmSyncEmployees, cancel: _vm.cancelSyncModal }
        },
        [
          _c(
            "a-form",
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "工號",
                    labelCol: { span: 4 },
                    wrapperCol: { span: 20 }
                  }
                },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入工号，多个工号请用逗号(,)分隔",
                      rows: 4,
                      "auto-size": { minRows: 4, maxRows: 6 }
                    },
                    model: {
                      value: _vm.employeeNos,
                      callback: function($$v) {
                        _vm.employeeNos = $$v
                      },
                      expression: "employeeNos"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "8px",
                        "font-size": "12px",
                        color: "#999"
                      }
                    },
                    [_vm._v("\n          示例: E00001,E00002,E00003\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }